import { DeviceType } from "../memberService/oaMembership"
import client from "./client"

enum MetadataStatus {
    SUCCESS,
}

enum ServiceType {
    SIGN_UP,
    RENEWAL,
    ARREARS,
    VOUCHER,
    CHANGE_MODE,
}

enum CardType {
    VISA,
    MASTERCARD,
}

enum PaymentMethod {
    CARDPAYMENT,
}

enum OrderStatus {
    NEW = `NEW`,
    PENDING = `PENDING`,
    SUCCESS = `SUCCESS`,
    CANCELLED = `CANCELLED`,
    FAILED = `FAILED`,
    SEMI_SUCCESS_ONE_TIME = `SEMI_SUCCESS_ONE_TIME`,
    SEMI_SUCCESS_RECURRING = `SEMI_SUCCESS_RECURRING`
}

enum PayementStatus {
    FAILED = `FAILED`,
    CANCELLED = `CANCELLED`,
    PENDING = `PENDING`,
    SUCCESS = `SUCCESS`,
    SEMI_SUCCESS_ONE_TIME = `SEMI_SUCCESS_ONE_TIME`,
    SEMI_SUCCESS_RECURRING = `SEMI_SUCCESS_RECURRING`
}

interface Response<T> {
    content: T,
    metadata: {
        status: MetadataStatus
    }
}

interface CreateOrderRequest {
    isRecurringPayment: boolean,
    isOneTimePayment: boolean,
    amount: string,
    serviceType: ServiceType
}

interface CreateOrderResponse {
    modifiedDttm: string,
    createdDttm: string,
    paymentTypeCode: string,
    description: string,
    errorDescription: string,
    errorCode: string,
    recurringBranchCode: string,
    recurringDDARefNo: string,
    recurringAcctNo: string,
    recurringAcctName: string,
    recurringCardType: CardType,
    recurringPaymentMethod: PaymentMethod,
    recurringPaymentStatus: PayementStatus,
    recurringToken: string,
    recurringMerchantId: string,
    oneTimeBranchCode: string,
    oneTimeDDARefNo: string,
    oneTimeAcctNo: string,
    oneTimeAcctName: string,
    oneTimeCardType: CardType,
    oneTimePaymentMethod: PaymentMethod,
    oneTimePaymentStatus: PayementStatus,
    oneTimeCardExpiryDate: string,
    oneTimeMerchantId: string,
    pgOrderId: string,
    orderStatus: OrderStatus,
    serviceType: ServiceType,
    isOneTimePayment: true,
    isRecurringPayment: true,
    orderAmount: string,
    clientOrderId: string,
    id: number
}

interface UpdatePaymentRequest {
    ClientOrderId: string,
    PGOrderId: string,
    Token: string,
    OrderAmount: string,
    OneTimeMerchantId: string,
    OneTimePaymentMethod: PaymentMethod,
    OneTimeCardExpiryDate: string,
    OneTimeCardType: CardType,
    OneTimePaymentStatus: PayementStatus,
    OneTimeAcctName: string,
    OneTimeAcctNo: string,
    OneTimeDDARefNo: string,
    OneTimeBranchCode: string,
    RecurringMerchantId: string,
    RecurringPaymentMethod: PaymentMethod,
    RecurringCardExpiryDate: string,
    RecurringCardType: CardType,
    RecurringPaymentStatus: PayementStatus,
    RecurringAcctName: string,
    RecurringAcctNo: string,
    RecurringDDARefNo: string,
    RecurringBranchCode: string,
    PaymentTypeCode: string,
    ErrorCode: string,
    ErrorDescription: string,
}

interface UpdatePaymentResponse {
    status: string,
    clientOrderId: string,
}

const postCreateOrder = (payload: CreateOrderRequest) => {
    return client.post<Response<CreateOrderResponse>>(
        `payment/create-order`,
        payload,
    )
}

const getInitiatePayment = (clientOrderId: string): string => {
    return `${window.myNtucConfig.mpBaseUrl}/payment-service/${process.env.REACT_APP_MP_VERSION}/payment/initiate-payment?clientOrderId=${clientOrderId}&callbackUrl=${window.myNtucConfig.signupPaymentCallbackUrl}&deviceType=${DeviceType.WEB}`
}

interface GetPaymentResultResponse {
    status: PayementStatus,
    clientOrderId: string,
}

const getPaymentResult = (data: string, iv: string, tag: string | null) => {
    return client.get<Response<GetPaymentResultResponse>>(
        `payment/payment-result/web`,
        {
            params: {
                Data: data,
                IV: iv,
                tag: tag,
            },
        },
    )
}

const postUpdatePayment = (payload: UpdatePaymentRequest) => {
    return client.post<UpdatePaymentResponse>(
        `payment/payment-update`,
        payload,
    )
}

const getPaymentOrderStatusBatch = (orderIds: string[]) => {
    return client.get(
        `payment/order-status-batch`,
        {
            params: {
                orderIds: orderIds.join(`,`),
            },
        },
    )
}

const getPaymentOrderStatus = (orderId: string) => {
    return client.get(`payment/order-status-batch/${orderId}`)
}

const getRecurringPayment = (clientOrderId: string): string => {
    return `${window.myNtucConfig.mpBaseUrl}/payment-service/${process.env.REACT_APP_MP_VERSION}/payment/initiate-payment?clientOrderId=${clientOrderId}&callbackUrl=${window.myNtucConfig.recurringPaymentCallbackUrl}&deviceType=${DeviceType.WEB}`
}

const getMembershipPayment = (clientOrderId: string): string => {
    return `${window.myNtucConfig.mpBaseUrl}/payment-service/${process.env.REACT_APP_MP_VERSION}/payment/initiate-payment?clientOrderId=${clientOrderId}&callbackUrl=${window.myNtucConfig.membershipPaymentCallbackUrl}&deviceType=${DeviceType.WEB}`
}

const redirectToPaymentGateway = (clientOrderId: string) => {
    window.location.replace(getInitiatePayment(clientOrderId))
}

export {
    postCreateOrder,
    getInitiatePayment,
    getPaymentResult,
    postUpdatePayment,
    getPaymentOrderStatus,
    getPaymentOrderStatusBatch,
    getRecurringPayment,
    getMembershipPayment,
    redirectToPaymentGateway,
}
export { PayementStatus}
export type { GetPaymentResultResponse }
